import {
  createContext,
  FC,
  PropsWithChildren,
  useContext,
  useMemo,
} from 'react';

interface SectionContextProps {
  basePath: string;
}

const SectionContext = createContext<SectionContextProps>({
  basePath: '',
});

export const SectionContextProvider: FC<
  PropsWithChildren<SectionContextProps>
> = ({ children, ...value }) => (
  <SectionContext.Provider value={value}>{children}</SectionContext.Provider>
);

export const useSectionContext = () => useContext(SectionContext);

export const useSectionBasePath = () => {
  const { basePath } = useSectionContext();
  return useMemo(() => basePath.split('/').slice(0, -1).join('/'), [basePath]);
};
